import * as $ from "jquery";
import {NotificationData, Observer} from '../Notifier';
import DataStorage from '../DataStorage';
import Status from '../Status';
import Data = require("diy/util/websiteData");

import l10n from 'diy/util/l10n';
import Backend from "../Backend";

interface NTFCenterNotification {
    type: number;
    severity?: number;
    sticky?: boolean;
    closable?: boolean;
    payload?: {
        content: string;
        status: string;
        cssSuffix?: string;
    };
    dismissed?: boolean;
}

export default class NTFCenterObserver implements Observer {
    private notificationApi: __Notification.Api;
    private notificationType: number;
    private notificationInstance: __Notification.Notification;

    setNotificationType(t: number) {
        this.notificationType = t;
    }

    setNotificationApi(api: __Notification.Api) {
        this.notificationApi = api;
    }

    notify(data: NotificationData) {
        let content: string;
        let iconCls: string;
        let notificationObject: NTFCenterNotification;
        let $body = $("body");

        switch (data.status) {
            case Status.INITIAL:
                content = `
                    <div class="notification-type-ext-website-import-new button-bar cp-style">
                        <div class="notification-type-ext-website-import-container">
                            ${l10n('migration.notification.init.text')}
                        </div>
                        <div class="notification-type-ext-website-import-menu">
                            <button id="notification-migration-possible-no"
                                    class="small blue-secondary button migrationNotificationClose"
                                    data-test="skip-import">
                                ${l10n('migration.notification.init.button.reject')}
                            </button>
                            <button id="notification-migration-possible-yes"
                                    class="small blue-primary button migrationNotificationClose"
                                    data-test="accept-import">
                                ${l10n('migration.notification.init.button.start')}
                            </button>
                        </div>
                    </div>`;
                iconCls = 'ui-icon-star-white';
                notificationObject = {
                    type: 17,
                    severity: 3,
                    sticky: false,
                    payload: {
                        content: content,
                        status: data.status
                    }
                };

                $body.on('click', '#notification-migration-possible-no', function() {
                    Backend.skipExternalImport(Data.getId());
                });

                $body.on('click', '#notification-migration-possible-yes', function() {
                    data.actionHandler();
                });
                break;

            case Status.SKIPPED:
                content = `
                    <div>${l10n("migration.notification.later.text")}</div>
                    <div class="button-bar cp-style">
                        <button id="notification-migration-start" class="small blue-primary">
                            <span class="ui-button-text">${l10n("migration.notification.later.button")}</span>
                        </button>
                    </div>`;
                iconCls = 'ui-icon-star';
                notificationObject = {
                    type: 15,
                    severity: 3,
                    sticky: false,
                    closable: false,
                    payload: {
                        content: content,
                        status: data.status
                    }
                };

                $body.on('click', '#notification-migration-start', function() {
                    data.actionHandler();
                });
                break;

            case Status.SUCCESS:
                if (!DataStorage.getMigrationSuccessNotificationRead()) {
                    content = `
                        <div class="notification-type-ext-website-import new button-bar cp-style">
                            <div class="notification-type-ext-website-import-container">
                                ${l10n('migration.notification.success.text')}
                            </div>
                            <div class="notification-type-ext-website-import-menu">
                                <button id="notification-migration-successful-close"
                                    class="small blue-secondary button migrationNotificationClose">
                                    ${l10n('migration.notification.success.button.reject')}
                                </button>
                                <button id="notification-migration-successful-manage-pages"
                                    class="small blue-primary button migrationNotificationClose">
                                    ${l10n('migration.notification.success.button.accept')}
                                </button>
                            </div>
                        </div>`;

                    iconCls = 'ui-icon-check-white';
                    notificationObject = {
                        type: 17,
                        severity: 4,
                        sticky: false,
                        payload: {
                            content: content,
                            status: data.status
                        }
                    };

                    $body.on('click', '#notification-migration-successful-close', function () {
                        DataStorage.setMigrationSuccessNotificationRead();
                    });

                    $body.on('click', '#notification-migration-successful-manage-pages', function () {
                        DataStorage.setMigrationSuccessNotificationRead();
                        diy.editor.deeplinking.requestPath([
                            {label: 'siteadmin', params: 'pages'}
                        ]);
                    });
                } else {
                    return;
                }
                this.notificationApi.deleteNotificationByType(15);
                break;

            default:
                return;
        }
        this.notificationApi.ready(() => {
            this.notificationInstance = this.getNotificationInstance(notificationObject.type);

            if (!this.notificationInstance) {
                this.notificationInstance = this.notificationApi.createNotification(notificationObject);
            } else {
                let lastNotificationBubbled = DataStorage.getLastNotificationBubbled();
                notificationObject.dismissed =
                    (lastNotificationBubbled === data.status) &&
                    (Status.SKIPPED !== data.status) &&
                    (this.notificationInstance.flashNotification === false);
                this.notificationApi.updateNotification(this.notificationInstance.getId(), notificationObject);
            }
            this.notificationInstance.setIconCls(iconCls);
            DataStorage.setLastNotificationBubbled(data.status);
        });
    }

    remove() {
        this.notificationApi.ready(() => {
            if (this.notificationInstance) {
                this.notificationApi.deleteNotificationByType(this.notificationType);
            }
        });
    }

    private getNotificationInstance(notificationType: number): __Notification.Notification {
        let notifications =  this.notificationApi.getNotificationsByType(notificationType);
        if (notifications.length > 0) {
            return notifications[0];
        }
        return null;
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/NotifierObservers/NTFCenterObserver.ts
 **/